exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.switch-toggle{height:24px;width:48px;position:relative;cursor:pointer;box-shadow:inset 0 0 1px rgba(0,0,0,.2)}div.switch-toggle,div.switch-toggle:after{display:block;background:#fff;transition:all .2s ease;border-radius:50px}div.switch-toggle:after{content:\"\";height:18px;width:18px;position:absolute;top:3px;left:3px;box-shadow:1px 1px 3px rgba(0,0,0,.3)}div.switch-toggle:before{content:\"\";position:absolute;right:1px;top:12px;color:#fff}div.switch-toggle:hover:after{left:5px}div.switch-toggle.switch-on:before{content:\"\";right:40px}.switch-toggle.switch-on{background:#0c0}div.switch-toggle.switch-on:after{left:26px}div.switch-toggle.switch-on:hover:after{left:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/theme-files/assets/widgets/input-switch/inputswitch-alt.css
// module id = 459
// module chunks = 0